import { ApiErrorResponse, estClient } from './estClient';

export interface Appeal {
  id: string;

  /**
   * @example '380671112233'
   */
  phone: string;
  name: string | null;
  custom_note: string | null;
  lead_id: string | null;
  is_new_lead: '1' | '0';
  object_id: string | null;
  unit_id: string | null;
  is_invalid: '1' | '0';
  status: string;
  source: string | null;
  source_type: string | null;

  /**
   * @example '2023-05-12 14:44:17'
   */
  created_at: string;
  created_by: string;

  /**
   * @example '2023-05-12 14:44:17'
   */
  underway_at: string | null;
  underway_by: string | null;

  /**
   * @example '2023-05-12 14:44:17'
   */
  last_action_at: string | null;
  last_action_by: string | null;

  /**
   * @example '2023-05-12 14:44:17'
   */
  closed_at: string | null;
  closed_by: string | null;

  lead_status_on_create: string | null;
  lead_status_on_close: string | null;
  gaClientId: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_content: string | null;
  utm_term: string | null;

  /**
   * Landing page url
   */
  fullUrl: string | null;
  ad_id: string | null;
  ad_name: string | null;
  adset_id: string | null;
  adset_name: string | null;
  campaign_id: string | null;
  campaign_name: string | null;
  form_id: string | null;
  form_name: string | null;
  is_organic: '1' | '0';
  platform: string | null;

  fields: {
    id: string;
    appeal_id: string;
    key:
      | 'ad_source'
      | 'ad_source_type'
      | 'custom_fields'
      | 'custom_note'
      | 'fullUrl'
      | 'gaClientId'
      | 'name'
      | 'object_id'
      | 'phone'
      | 'unit_id'
      | 'utm_campaign'
      | 'utm_content'
      | 'utm_medium'
      | 'utm_source'
      | 'utm_term'
      | 'adset_id'
      | 'adset_name'
      | 'ad_id'
      | 'ad_name'
      | 'campaign_id'
      | 'campaign_name'
      | 'form_id'
      | 'form_name'
      | 'is_organic'
      | 'platform'
      | 'source'
      | 'source_type';
    value: string;
  }[];
}

class AppealsApi {
  async getAll(
    params: {
      maxStatus?: 0 | 1 | 99;

      /**
       * bitmask
       */
      invalid?: string;
    } = {},
  ): Promise<Appeal[]> {
    const resp = await estClient.get<
      { success: true; appeals: Appeal[] } | ApiErrorResponse
    >('/api/appeal/get/all', {
      query: params,
    });

    if (!resp.success) {
      throw Object.assign(
        new Error(`Error fetching appeals (${resp.code}): ${resp.message}`),
        {
          resp,
        },
      );
    }

    return resp.appeals;
  }
}

export const appealsApi = new AppealsApi();
